// Import model
import { EstimateOptions } from '../models/EstimateOptions';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)
import { InstallationTypeOptionSerializer } from './InstallationTypeOptionSerializer';
import { PatternTypeOptionSerializer } from './PatternTypeOptionSerializer';
import { Fcb2BProductTypeOptionSerializer } from './Fcb2BProductTypeOptionSerializer';
import { Fcb2BUnderlaymentOptionSerializer } from './Fcb2BUnderlaymentOptionSerializer';

/**
 * Serializer for EstimateOptions - handles JSON serialization and deserialization with type validation
 */
export class EstimateOptionsSerializer {
  /**
   * Deserializes a JSON string into a EstimateOptions instance
   */
  static deserialize(json: string): EstimateOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a EstimateOptions instance
   */
  static fromObject(obj: any): EstimateOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to EstimateOptions');
    }

    // Handle polymorphic deserialization using discriminator
    const discriminator = obj['type'];

    switch (discriminator) {
      case 'InstallationType':
        return InstallationTypeOptionSerializer.fromObject(obj);
      case 'PatternType':
        return PatternTypeOptionSerializer.fromObject(obj);
      case 'ProductType':
        return Fcb2BProductTypeOptionSerializer.fromObject(obj);
      default:
        // Fall through to base type deserialization
        break;
    }

    const instance: EstimateOptions = {
      description: obj['description'] as string | undefined,
      externalId: obj['externalId'] as string | undefined,
      name: obj['name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      type_: obj['type'] as string,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of EstimateOptions instances
   */
  static deserializeArray(json: string): EstimateOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a EstimateOptions instance to a JSON string
   */
  static serialize(instance: EstimateOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a EstimateOptions instance to a plain object
   */
  static toObject(instance: EstimateOptions): any {
    return {
      'description': instance.description,
      'externalId': instance.externalId,
      'name': instance.name,
      '_id': instance.id,
      'type': instance.type_,
    };
  }

  /**
   * Serializes an array of EstimateOptions instances to a JSON string
   */
  static serializeArray(instances: EstimateOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
